module.exports = __webpack_public_path__ + "static/img/customization_banner_bg.78e1eab.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/enterpriseEdition/customization_banner_bg.jpg
// module id = 72x2
// module chunks = 14